<template>
  <div class="container my-5">
    <h1 class="mb-3">Faça seu login para navegar</h1>
    <p>
      Para fazer seu login, insira um e-mail válido e clique em Enviar link de Agendamento. Você
      receberá um e-mail com um link, clique nele para abrir a plataforma.
    </p>
    <p class="service-notice">
      Sistema exclusivo para agendamento de visitas ao Museu Catavento em São Paulo - SP, Capital.
    </p>
    <form @submit.prevent="handleLogin" class="d-flex flex-column gap-5">
      <input type="email" v-model="email" placeholder="Digite seu e-mail" required />
      
      <div class="d-flex gap-5">
        <label>
          <input type="radio" v-model="userType" value="diretor_professor_responsavel" checked required />
          Escola ou Instituição: Diretor/Professor/Responsável
        </label>
        <label>
          <input type="radio" v-model="userType" value="agencia_turismo" required />
          Agência de Turismo
        </label>
      </div>
      
      <button class="btn btn-primary" type="submit">Enviar link de agendamento</button>
    </form>
    <div v-if="magicLink">
      <p>Link mágico para teste:</p>
      <a :href="magicLink">{{ magicLink }}</a>
    </div>

    <!-- Modal -->
    <div v-if="showModal" class="modal-overlay">
      <div class="modal-content">
        <div class="spinner"></div>
       <h2>Enviando o e-mail...</h2>
       <p>Em instantes confira na sua caixa de entrada ou spam</p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import axios from 'axios';
import router from '@/router';

export default {
  setup() {
    const email = ref('');
    const userType = ref('diretor_professor_responsavel');
    const magicLink = ref('');
    const showModal = ref(false);

    const handleLogin = async () => {
      showModal.value = true; // Mostra o modal
      try {
        const token = await mecanismolinkmagico(email.value);
        const type = (
          email.value === 'admin.agendamento@cataventomaster.com' || 
          email.value === 'bruno.oliveira.participacoes@gmail.com' ||
          email.value === 'jessica.baptista@cataventocultural.org.br' ||
          email.value === 'erica.felix@cataventocultural.org.br' ||
          email.value === 'fernanda.alfeu@cataventocultural.org.br' ||
          email.value === 'pauliceia.jesus@cataventocultural.org.br' ||
          email.value === 'octavio.martinez@cataventocultural.org.br' ||
          email.value === 'mariana.jesus@cataventocultural.org.br'
        ) ? 'eurbw34r98gh' : userType.value;

        await enviarlinkmagico(token, email.value, type);
        setTimeout(() => {
          showModal.value = false; // Oculta o modal após 3 segundos
          
          router.push('/sucesso');
        }, 3000);
      } catch (error) {
        showModal.value = false; // Oculta o modal em caso de erro
        console.error('Erro ao enviar e-mail:', error);
      }
    };

    const mecanismolinkmagico = (emailc) => {
      return axios.get('https://museucatavento.org.br/sistema-agendamento/mecanismotoken2.php?email='+emailc)
        .then(response => {
          return response.data;
        })
        .catch(error => {
          console.error('Erro ao enviar e-mail:', error);
          throw error; // Propagar o erro para que possa ser tratado pelo chamador
        });
    }

    const enviarlinkmagico = (tok, emailc, typeu) => {
      return axios.get(`https://museucatavento.org.br/envio/handlelogin.php?seuemail=${emailc}&token=${tok}&type=${typeu}`)
        .then(() => {
          // Link enviado com sucesso
        })
        .catch(error => {
          console.error('Erro ao enviar e-mail:', error);
          // Tratamento de erro adicional
          // Considerar reexibir os campos de entrada de e-mail caso necessário
          throw error;
        });
    }

    return {
      email,
      userType,
      magicLink,
      showModal,
      handleLogin,
    };
  },
};
</script>

<style scoped>
.container {
  max-width: 760px;
  background: var(--catavento-surface, #fff);
  border: 1px solid var(--catavento-border, #d9e1ea);
  border-radius: var(--catavento-radius, 8px);
  box-shadow: var(--catavento-shadow, 0 10px 28px rgba(20, 30, 45, 0.12));
  padding: clamp(1.25rem, 4vw, 2rem);
  text-align: left;
}

form {
  gap: 1.5rem !important;
}

form > .d-flex {
  flex-wrap: wrap;
  gap: 1rem !important;
}

label {
  display: flex;
  gap: 0.5rem;
  align-items: flex-start;
}

.service-notice {
  background: #eff6ff;
  border: 1px solid #c9ddf3;
  border-radius: 8px;
  color: var(--catavento-blue, #165a96);
  font-weight: 800;
  margin: 1rem 0 1.25rem;
  padding: 0.85rem 1rem;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.851);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: transparent;
  padding: 20px;
  border-radius: 10px;
  text-align: center;
  box-shadow: none;
}
.modal-content h2{
  color: white;
  margin-top: 50px;
}
.modal-content p{
  color: white;
}

.spinner {
  border: 8px solid #f3f3f3;
  border-radius: 50%;
  border-top: 8px solid #3498db;
  margin: 0 auto;
  width: 60px;
  height: 60px;
  -webkit-animation: spin 2s linear infinite;
  animation: spin 2s linear infinite;
}

@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

@media (max-width: 767px) {
  .container {
    margin-top: 1rem !important;
  }

  button {
    width: 100%;
  }
}
</style>
